import imgSrc from "./printCustomerLogo.svg";

/**
 * fix svg component to img cause of svg utils position bug
 */
export default function PrintCustomerLogo() {
  return <img src={imgSrc} width="207.854px" height="34px" />;
}
